import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { getIsReliable, getHasProblems } from '../../selectors/newbuilding';
import { trackRightReliableLabelClick } from './tracking';
import { RightReliableBanner } from '../../components/RightReliableLabelRedesigned';
import { reliabilitySelector } from '../../selectors/reliability/reliabilitySelector';

export function RightReliableLabelContainer() {
  const isReliable = useSelector(getIsReliable);
  const hasProblems = useSelector(getHasProblems);
  const reliability = useSelector(reliabilitySelector);

  if (!isReliable && !hasProblems) {
    return null;
  }

  const onReliableLabelClick = (anchor: string, label: string) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackRightReliableLabelClick(label);
  };

  return (
    <RightReliableBanner
      reliability={reliability}
      onProblemClick={onReliableLabelClick('#reliable', 'floating_block_problem_building')}
      onReliableClick={onReliableLabelClick('#reliable', 'floating_block_reliable_dev')}
    />
  );
}
